import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import ViewActionActivities from "./ViewActionActivities";
import ViewActionDetails from "./ViewActionDetails";
import { useSelector, useDispatch } from "react-redux";
import { logOut } from "../../redux/actions/authActions/authAction";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import {
  fetchSingleAction,
  setIsCheckRequired,
} from "../../redux/actions/actionAction/ActionAction";
import Alert from "../Common/Alert";
import ActionComments from "./ActionComments";
import BackButton from "../Common/Backbutton";

const ViewActionPage = React.memo(() => {
  const actionData = useSelector((state) => state.action);
  let { id } = useParams();
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  useEffect(() => {
    document.title = "View Action: MinutesVault";
    if (!authData.isInValidUser && accessToken) {
      const fetchData = async () => {
        if (accessToken) {
          const result = await dispatch(fetchSingleAction(id, accessToken));
          console.log(result);
          if (result?.isReload === true) {
            // alert(11);
            window.location.reload();
            dispatch(setIsCheckRequired(false));
          } else {
            // alert(22);
            dispatch(setIsCheckRequired(true));
          }
        }
      };

      fetchData();
    }
    return () => {};
  }, [id, authData?.isInValidUser]);

  const location = useLocation();

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  const navigate = useNavigate();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }

  const accessToken = localStorage.getItem("accessToken");
  const employeeData = useSelector((state) => state.user);

  const username = employeeData?.userData?.name;
  const userId = employeeData?.userData?._id;

  const scrollId = location.state?.scrollToId;
  console.log("actionData", actionData);
  return (
    <>
      {actionData?.singleActionDetails !== null ? (
        // 👉 Action details available
        <div className="main-content">
          <div className="meeting-header-text line-height-h4 d-flex align-items-center justify-content-between">
            <h4>Action Details</h4>
            <BackButton show={camefromPreviousPage} />
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <ViewActionDetails actionId={id} />
              <div className="action-comments-div mt-4">
                <div className="meeting-header-text line-height-h4 comment-header-text">
                  <h4 id="scroll-to-comment">Comments</h4>
                </div>
                <ActionComments
                  actionId={id}
                  userData={employeeData?.userData}
                  scrollToId={location.state?.scrollToId}
                />
              </div>
            </div>
            <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <ViewActionActivities
                actionId={id}
                action={actionData?.singleActionDetails}
              />
            </div>
          </div>
        </div>
      ) : actionData?.loading ? (
        // 👉 Loader first
        <div className="main-content">
          <div className="meeting-header-text line-height-h4">
            <h4>Action Details</h4>
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <form className="mt-2 details-form details-form-right">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Loader />
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : actionData?.singleActionDetails === null &&
        actionData.hasFetched &&
        !actionData.isSuccess ? (
        // 👉 Show No Data only when not loading
        <div className="main-content">
          <div className="meeting-header-text line-height-h4">
            <h4>Action Details</h4>
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <form className="mt-2 details-form details-form-right">
                <div className="row">
                  <Alert
                    status={"info"}
                    message={"No data available."}
                    timeoutSeconds={0}
                  />
                  <NoDataFound dataType={"meeting"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
});
export default ViewActionPage;
